<template>
  <div>
    <v-container class="mt-5 mb-2">
      <v-card class="pa-5">
      <v-row no-gutters>
        <v-col cols="12" lg="1">
          <Validate :v="$v.form.anoletivo">
            <v-autocomplete
              slot-scope="{ props }"
              v-bind="props"
              :items="anoOptions"
              outlined
              label="Ano Letivo*"
              no-data-text="Opções não disponíveis"
              :disabled="loading || turmasLoading || saidasLoading"
              :background-color="loading || turmasLoading || saidasLoading ? '#f2f2f2' : null"
              v-model="form.anoletivo"
              @change="onChangeAno">
            </v-autocomplete>
          </Validate>
        </v-col>
        <v-col cols="12" lg="9" class="px-lg-3">
          <Validate :v="$v.form.identificadorcardapioescola">
            <v-select
              slot-scope="{ props }"
              v-bind="props"
              v-model="form.identificadorcardapioescola"
              :items="cardapioOptions"
              item-text="descricaotitulocardapio"
              item-value="identificadorcardapioescola"
              :disabled="loading || turmasLoading || saidasLoading"
              :background-color="loading || turmasLoading || saidasLoading ? '#f2f2f2' : null"
              label="Título Cardápio*"
              outlined
              ref="cardapio"
              menu-props="offsetY"
              :no-data-text="cardapiosLoading ? 'Carregando dados, aguarde...' :  'Nenhuma opção carregada'"
              :loading="cardapiosLoading"
              loader-height="3"
              @focus="loadCardapioOptions"
              @change="onChangeCardapio">
            </v-select>
          </Validate>
        </v-col>
        <v-col cols="12" lg="2">
          <Validate :v="$v.form.cdturma">
            <v-select
              slot-scope="{ props }"
              v-bind="props"
              v-model="form.cdturma"
              :items="turmaOptions"
              item-text="nmturma"
              item-value="cdturma"
              :disabled="loading || !form.identificadorcardapioescola || saidasLoading"
              :background-color="loading || !form.identificadorcardapioescola || saidasLoading ? '#f2f2f2' : null"
              label="Turma*"
              outlined
              ref="turma"
              menu-props="offsetY"
              :no-data-text="turmasLoading ? 'Carregando dados, aguarde...' :  'Nenhuma opção carregada'"
              :loading="turmasLoading"
              loader-height="3"
              @focus="loadTurmaOptions"
              @change="loadSaidas">
            </v-select>
          </Validate>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
            <v-skeleton-loader v-show="saidasLoading"
              id="skeleton"
              class="mb-3 pa-5"
              elevation="2"
              type="table-heading, table-row-divider@4"
            ></v-skeleton-loader>
          <v-card v-show="!saidasLoading" style="overflow: auto;">
            <table class="table-siged">
            <thead>
              <tr>
                <th>Refeição</th>
                <th>Segunda</th>
                <th>Terça</th>
                <th>Quarta</th>
                <th>Quinta</th>
                <th>Sexta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(horario, index) of gradeHorarios" :key="index">
                <td style="text-align:center;">{{refeicoes[horario.indicarefeicaocardapio]}}<br>{{horario.horacardapio.substring(0,5)}}</td>
                <td v-for="(diavalue) of dias" :key="diavalue">
                  <div style="display:flex;justify-content:center;align-items:end; padding:10px 5px;">
                    <v-checkbox
                      hide-details
                      style="margin:0px;padding:0px;"
                      v-model="quadroSaidas[`${horario.indicarefeicaocardapio}-${horario.horacardapio}`][diavalue].sai"
                      :disabled="loading || !form.cdturma || saidasLoading"
                      @change="(e) => { e ? '' : quadroSaidas[`${horario.indicarefeicaocardapio}-${horario.horacardapio}`][diavalue].localExterno = null}">
                    </v-checkbox>
                    <Validate :v="$v.form.identificadorcardapioescola">
                      <v-select
                        style="max-width:200px;"
                        slot-scope="{ props }"
                        v-bind="props"
                        v-model="quadroSaidas[`${horario.indicarefeicaocardapio}-${horario.horacardapio}`][diavalue].localExterno"
                        label="Sai para"
                        :items="locaisExternosOptions"
                        item-text="nomelocalexterno"
                        item-value="identificadorlocalexterno"
                        :disabled="!quadroSaidas[`${horario.indicarefeicaocardapio}-${horario.horacardapio}`][diavalue].sai || turmasLoading"
                        hide-details
                        menu-props="offsetY"
                        :no-data-text="locaisExternosLoading ? 'Carregando dados, aguarde...' :  'Nenhuma opção carregada'"
                        :loading="locaisExternosLoading && quadroSaidas[`${horario.indicarefeicaocardapio}-${horario.horacardapio}`][diavalue].sai"
                        loader-height="3"
                        @focus="loadLocaisExternosOptions">
                      </v-select>
                    </Validate>
                  </div>
                </td>
              </tr>
            </tbody>
            </table>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters style="margin-top:27px;">
        <v-col cols="auto">
          <v-btn width="90px" type="submit" @click="salvar" :loading="loading" :disabled="!form.cdturma || saidasLoading" :dark="!!form.cdturma && !saidasLoading" small color="teal"  class="rounded-sm">Salvar</v-btn>
        </v-col>
      </v-row>
      </v-card>
    </v-container>

    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0 || (!quadroSaidasEhValido() && $v.$dirty)" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty || (!quadroSaidasEhValido() && $v.$dirty)"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0">
      <div class="d-flex justify-space-between align-center">
        <span> {{ submitText }}</span>
        <v-btn class="text-right" variant="text" icon @click="snackbar = false"> <v-icon>close</v-icon> </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { required, integer, maxLength, array } from 'vuelidate/lib/validators';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const CardapioEscolaRepository = RepositoryFactory.get("cardapioEscola");
const CardapioTurmaRepository = RepositoryFactory.get("cardapioTurma");
const CardapioRepository = RepositoryFactory.get("cardapio");
const SaidaTurmaRepository = RepositoryFactory.get("saidaTurma");
const TurmaRepository = RepositoryFactory.get("turma");
const LocalExternoRepository = RepositoryFactory.get("localExterno");

const setFormInicial = () => ({
  anoletivo: null,
  identificadorcardapioescola: '',
  cdturma: '',
  turmas: [],
});

export default {
  name: 'CardapioTurma',
  data() {
    return {
      form: setFormInicial(),
      loading: false,
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      cardapioOptions: [],
      turmaOptions: [],
      cardapiosLoading: false,
      turmasLoading: false,
      saidas: [],
      saidasLoading: false,
      locaisExternosOptions: [],
      locaisExternosLoading: false,
      horarios: [],
      refeicoes: { 1: 'Entrada', 2: 'Lanche', 3: 'Almoço', 4: 'Jantar'},
      dias: {'Segunda': 2, 'Terça': 3, 'Quarta': 4, 'Quinta': 5, 'Sexta': 6},
      quadroSaidas: {}
    };
  },
  computed: {
    ...mapGetters(['getAnoAtualServidor', 'getAnoInicioSistema', 'school']),
    anoOptions() {
      if (!this.getAnoAtualServidor) { return []; }
      let retornoOptions = [];
      for (let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i--) {
        retornoOptions.push({ text: i, value: i });
      }
      return retornoOptions;
    },
    gradeHorarios() {
      if (!this.form.cdturma) { return []; }
      let horariosPorTurma = this.horarios.filter( h => h.indicaturnocardapio == this.turmaOptions.find(t => t.cdturma == this.form.cdturma)?.cnperiodo);
      return _.orderBy(
        _.uniqBy(horariosPorTurma, "horacardapio"),
        'horacardapio'
      );
    }
  },
  validations: {
    form: {
      anoletivo: { required, integer },
      identificadorcardapioescola: { required, integer },
      cdturma: { required },
    },
  },
  async mounted() {
    this.form.anoletivo = this.getAnoAtualServidor;
    this.$Progress.finish();
  },
  methods: {
    montarQuadroSaidas() {
      let saidas = {};
      this.gradeHorarios.forEach( h =>  {
      // for (let refeicao = 1; refeicao <= 4; refeicao++) {
        if (!(`${h.indicarefeicaocardapio}-${h.horacardapio}` in saidas)) saidas[`${h.indicarefeicaocardapio}-${h.horacardapio}`] = {};
        for (let diaSemana = 2; diaSemana <= 6; diaSemana++) {
          saidas[`${h.indicarefeicaocardapio}-${h.horacardapio}`][diaSemana] = { 'sai': false, localExterno: null, horariocardapio: h.horacardapio }
        }
      })
      return saidas;
    },
    quadroSaidasEhValido() {
      let valido = true;
      Object.values(this.quadroSaidas).forEach(r => {
        Object.values(r).forEach(dia => {
          if (dia.sai && dia.localExterno == null) {
            valido = false;
          }
        })
      })
      return valido;
    },
    async salvar() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.quadroSaidasEhValido()) return;

      this.loading = true
      this.msgArrayError = []

      try {
        const { data } = await SaidaTurmaRepository.inserirSaidas(this.form.identificadorcardapioescola, this.form.cdturma, this.quadroSaidas);
        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];
        this.$v.$reset()
      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      } finally {
        this.loading = false;
      }
    },

    async loadCardapioOptions() {
      if (this.cardapioOptions.length) return;
      this.cardapiosLoading = true
      const { data } = await CardapioTurmaRepository.buscarCardapiosPorEscola(this.form.anoletivo, this.school.cdtipesc, this.school.cdescola);
      this.cardapioOptions = [...data.results]
      this.cardapiosLoading = false
    },

    async loadTurmaOptions() {
      if (this.turmaOptions.length) return;
      this.turmasLoading = true
      const { data } = await CardapioTurmaRepository.buscarturmasPorCardapio(this.form.identificadorcardapioescola);
      this.turmaOptions = [...data.results]
      this.turmasLoading = false
    },

    async loadLocaisExternosOptions() {
      if (this.locaisExternosOptions.length) return;
      this.locaisExternosLoading = true
      const { data } = await LocalExternoRepository.listarLocaisExternos();
      this.locaisExternosOptions = [...data.results];
      this.locaisExternosLoading = false
    },

    async loadSaidas(cdturma) {
      this.$v.$reset()
      this.quadroSaidas = this.montarQuadroSaidas();
      this.saidasLoading = true
      this.saidas = [];
      this.$refs.turma.blur();

      let consultas = [];
      let buscaSaidas = SaidaTurmaRepository.buscarSaidas(this.form.identificadorcardapioescola, this.form.cdturma);

      consultas.push(buscaSaidas);

      if (!this.locaisExternosOptions.length) {
        let buscaLocaisExternos = LocalExternoRepository.listarLocaisExternos();
        consultas.push(buscaLocaisExternos);
      }

      const result = await Promise.all(consultas);

      if (!this.locaisExternosOptions.length) {
        this.locaisExternosOptions = result[1].data.results
      }

      this.preencherQuadroSaidas(result[0].data.results);
      this.saidasLoading = false
    },

    async preencherQuadroSaidas(saidas) {
      this.limparQuadroSaidas();    
      saidas.forEach( saida => {
        this.quadroSaidas[`${saida.indicarefeicaocardapio}-${saida.horacardapio}`][saida.diacardapio].sai = true;
        this.quadroSaidas[`${saida.indicarefeicaocardapio}-${saida.horacardapio}`][saida.diacardapio].localExterno = saida.identificadorlocalexterno;
      });
    },

    async limparQuadroSaidas() {
      Object.keys(this.quadroSaidas).forEach(r => {
        Object.keys(this.quadroSaidas[r]).forEach(d => {
          this.quadroSaidas[r][d].sai = false;
          this.quadroSaidas[r][d].localExterno = null;
        });
      });
    },

    async onChangeAno() {
      this.cardapioOptions = [];
      this.form.identificadorcardapioescola = '';
      this.turmaOptions = [];
      this.form.cdturma = '';
      this.saidas = [];
      this.limparQuadroSaidas();
      this.$v.$reset()
    },

    async onChangeCardapio(identificadorcardapioescola) {
      this.horarios = this.cardapioOptions.find(c => c.identificadorcardapioescola == identificadorcardapioescola).horarios;
      this.turmaOptions = [];
      this.form.cdturma = '';
      this.saidas = [];
      this.limparQuadroSaidas();
      this.$v.$reset()
    },
  },
};
</script>

<style scoped>
.turmas-select-wrapper.disabled {
  background-color: #f2f2f2;
}
.turmas-select-wrapper {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius:4px;
  position:relative;
  padding: 10px 12px 5px 12px;
  min-height: 56px;
}
.turmas-select-wrapper > h2 {
  position:absolute;
  top: -10px;
  left: 10px;
  background-color:white;
  color:rgba(0, 0, 0, 0.6);
}
.turmas-select-wrapper + span {
  font-size:12px;
  color:rgba(0, 0, 0, 0.6);
  padding-left: 10px;
  display: inline-block;
}
</style>
